import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=173dae0e&scoped=true&"
import script from "./Announcement.vue?vue&type=script&lang=ts&"
export * from "./Announcement.vue?vue&type=script&lang=ts&"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=173dae0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173dae0e",
  null
  
)

export default component.exports